var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91668 3.26659C6.22768 3.26659 5.58286 3.4463 5.02658 3.76031C4.40824 4.10934 3.89909 4.6245 3.5625 5.24337C3.43887 5.47069 3.15107 5.5565 2.91969 5.43504C2.6883 5.31359 2.60095 5.03084 2.72458 4.80353C3.14522 4.03011 3.78085 3.38706 4.55328 2.95104C5.24973 2.55791 6.05722 2.33325 6.91668 2.33325C9.54011 2.33325 11.6668 4.42259 11.6668 6.99992C11.6668 9.57725 9.54011 11.6666 6.91668 11.6666C4.75039 11.6666 2.92394 10.2424 2.35224 8.29597C2.27951 8.04834 2.42488 7.78967 2.67694 7.71821C2.929 7.64676 3.19229 7.78957 3.26503 8.0372C3.72254 9.59481 5.1849 10.7333 6.91668 10.7333C9.01542 10.7333 10.7168 9.06178 10.7168 6.99992C10.7168 4.93806 9.01542 3.26659 6.91668 3.26659Z",
    fill: "#0085E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28391 4.96203C5.21551 4.70675 4.95312 4.55526 4.69784 4.62366L3.19903 5.02527L2.79743 3.52646C2.72903 3.27118 2.46663 3.11969 2.21136 3.18809C1.95608 3.25649 1.80459 3.51888 1.87299 3.77416L2.33652 5.50408C2.43912 5.88699 2.83271 6.11423 3.21563 6.01163L4.94555 5.5481C5.20082 5.4797 5.35231 5.21731 5.28391 4.96203Z",
    fill: "#0085E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.c02ca99616fc3f1a15ecd80c21412965.svg";
export { ForwardRef as ReactComponent };